<h3>Contractors</h3>

<wm-contractor-registration-list
  [id]="id"
  [initialColumns]="columns"
  [staticFilters]="filterOptions"
></wm-contractor-registration-list>
